<div class="row page-header">
    <div class="col-12">
        <h1>
            Job PO Configuration
            <small>Configure vendors and users allowed to create POs for each job</small>
        </h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <div class="row">
        <div class="col-lg-12">
            <!-- Job Selector -->
            <div class="row action-toolbar">
                <div class="col-12">
                    <form class="form-inline">
                        <div class="form-group" style="margin-right: 15px">
                            <label for="job" style="display: block">Job</label>
                            <wj-combo-box
                                [(ngModel)]="selectedJob"
                                name="job"
                                id="job"
                                [itemsSource]="jobMap"
                                [displayMemberPath]="'display'"
                                [selectedValuePath]="'value'"
                                [placeholder]="'Select a job'"
                                (selectedIndexChanged)="onJobChanged()"
                                style="min-width: 400px"
                            ></wj-combo-box>
                        </div>
                        <div class="form-group">
                            <label for="jobType" style="display: block">Job Type</label>
                            <input
                                type="text"
                                id="jobType"
                                class="form-control"
                                [value]="selectedJobType"
                                readonly
                                style="min-width: 150px"
                            />
                        </div>
                    </form>
                </div>
            </div>

            @if (selectedJob) {
                <div class="row">
                    <!-- Allowed Vendors Column -->
                    <div class="col-lg-6 col-12">
                        <h4>Allowed Vendors</h4>
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="vendorGrid"></action-toolbar-count>
                                    @if (canEdit) {
                                        <button class="btn btn-sm btn-primary" style="margin-left: 10px" (click)="manageVendors()">
                                            Manage Vendors
                                        </button>
                                        <button
                                            class="btn btn-sm btn-outline-primary"
                                            style="margin-left: 5px"
                                            (click)="initializeFromTemplate()"
                                            [disabled]="isInitializing"
                                        >
                                            @if (isInitializing) {
                                                <span><fa-icon [icon]="faSync" [animation]="'spin'"></fa-icon>&nbsp;Initializing...</span>
                                            } @else {
                                                <span><fa-icon [icon]="faSync"></fa-icon>&nbsp;Add from Template</span>
                                            }
                                        </button>
                                    }
                                    <action-toolbar-search name="vendorSearch" [(ngModel)]="vendorGrid.filter"></action-toolbar-search>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="vendorMainGrid"
                                    #vendorMainGrid
                                    appAutoSize
                                    [padding]="120"
                                    (initialized)="vendorGrid.initialize(vendorMainGrid)"
                                    (destroy)="vendorGrid.destroy()"
                                    [itemsSource]="vendorGrid.view"
                                    (cellEditEnded)="onVendorCellEditEnded(vendorMainGrid, $event)"
                                >
                                    <wj-flex-grid-column
                                        [header]="'Vendor Name'"
                                        [binding]="'vendorName'"
                                        [minWidth]="200"
                                        [width]="'3*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Phase'"
                                        [binding]="'phase'"
                                        [dataMap]="phaseMap"
                                        [isRequired]="false"
                                        [width]="'*'"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Vendor ID'"
                                        [binding]="'vendorId'"
                                        [width]="80"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>

                    <!-- Authorized Users Column -->
                    <div class="col-lg-6 col-12">
                        <h4>Authorized PO Users</h4>
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="userGrid"></action-toolbar-count>
                                    @if (canEdit) {
                                        <button class="btn btn-sm btn-primary" style="margin-left: 10px" (click)="manageUsers()">
                                            Manage Users
                                        </button>
                                        <button
                                            class="btn btn-sm btn-outline-primary"
                                            style="margin-left: 5px"
                                            (click)="addUsersFromViewpoint()"
                                            [disabled]="isAddingFromViewpoint"
                                        >
                                            @if (isAddingFromViewpoint) {
                                                <span><fa-icon [icon]="faSync" [animation]="'spin'"></fa-icon>&nbsp;Adding...</span>
                                            } @else {
                                                <span><fa-icon [icon]="faSync"></fa-icon>&nbsp;Add from Viewpoint</span>
                                            }
                                        </button>
                                    }
                                    <action-toolbar-search name="userSearch" [(ngModel)]="userGrid.filter"></action-toolbar-search>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="userMainGrid"
                                    #userMainGrid
                                    appAutoSize
                                    [padding]="120"
                                    (initialized)="userGrid.initialize(userMainGrid)"
                                    (destroy)="userGrid.destroy()"
                                    [itemsSource]="userGrid.view"
                                >
                                    <wj-flex-grid-column
                                        [header]="'User Name'"
                                        [binding]="'userName'"
                                        [minWidth]="200"
                                        [width]="'*'"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'HR Ref'"
                                        [binding]="'userHrRef'"
                                        [width]="100"
                                        [isReadOnly]="true"
                                    ></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </div>
    </div>
</div>
